<template>
  <div class="news">
    <div class="title">
      <p class="en">NEWS CENTER</p>
      <p class="cn">{{$t("home.news.title")}}</p>
    </div>
    <div class="container">
      <swiper :options="swiperOption" :not-next-tick="notNextTick" ref="mySwiper" class="ms">
        <swiper-slide class="item" v-for="item in newList" :key="item.id">
          <div class="left">
            <div class="time">{{item.publishTime.substring(0,10).replace(/-/g,'/')}}</div>
            <div class="box">
              <happy-scroll color="rgba(0,0,0,0.5)" size="5" class="news-scroll" resize>
                <div class="con">
                  <div class="box-title">{{getLang === 'zh' ? item.title : item.fantiTitle}}</div>
                  <div class="box-text">{{getLang === 'zh' ? item.subheading : item.fantiSubheading}}</div>
                </div>
              </happy-scroll>
            </div>
            <div class="more"><router-link to="/news">MORE</router-link></div>
          </div>
          <div class="right">
            <div class="img"><img :src="item.cover"/></div>
            <div class="bg"><img src="~assets/home/newsbg.png"/></div>
          </div>
        </swiper-slide>
        <div class="swiper-button-prev swiper-btn" slot="button-prev"></div>
        <div class="swiper-button-next swiper-btn" slot="button-next"></div>
      </swiper>
      <div class="icon">
        <div class="line"></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'News',
  data () {
    return {
      defaultList: [
        {
          cover: 'static/images/home/news1.jpg',
          publishTime: '2018-06-14 00:00:00',
          title: '新福港·筑爱义工队第一站',
          subheading: '新福港地产成立的‘筑爱·义工队’在端午佳节来临之际，于广州荔湾区岭南街道开展对帮扶“浓情端午·筑爱岭南”志愿慰问活动，并且为残障特困家庭准备粽子、风扇、油等生活用品，让残障人士及孤老独居长者过上一个欢乐祥和的端午节。',
          fantiTitle: '新福港·築愛義工隊第一站',
          fantiSubheading: '新福港地產成立的‘築愛·義工隊’在端午佳節來臨之際，於廣州荔灣區嶺南街道開展對幫扶“濃情端午·築愛嶺南”志願慰問活動，並且為殘障特困家庭準備粽子、風扇、油等生活用品，讓殘障人士及孤老獨居長者過上一個歡樂祥和的端午節。'
        },
        {
          cover: 'static/images/news/20180628_bg.jpg',
          publishTime: '2018-06-28 00:00:00',
          title: '新福港地产2018员工运动会-历奇派对',
          subheading: `2018年6月28日，新福港地产的员工带着狂热，顷刻间席卷了整座佛山新DNA购物中心。随着刮起的夏风，扫过这个体内每一个历奇基因，蕴涵着袭人的热量，共同打开首个【新福港地产员工趣味运动会の历奇派对】的“蓝色大门”。`,
          fantiTitle: '新福港地產2018員工運動會-歷奇派對',
          fantiSubheading: `2018年6月28日，新福港地產的員工帶著狂熱，頃刻間席捲了整座佛山新DNA購物中心。隨著颳起的夏風，掃過這個體內每一個歷奇基因，蘊涵著襲人的熱量，共同開啟首個【新福港地產員工趣味運動會の歷奇派對】的“藍色大門”。`
        },
        {
          cover: 'static/images/news/20180824_03.jpg',
          publishTime: '2018-08-24 00:00:00',
          title: '新福港·筑爱义工队第二站【开学季】',
          subheading: `随着火辣辣的暑假结束，又迎来九月开学季了！   2018年8月24日新福港筑爱义工团队开展了 “暖阳开学季” 爱心捐赠活动，为智障儿童放送开学礼。`,
          fantiTitle: '新福港·築愛義工隊第二站【開學季】',
          fantiSubheading: `隨著火辣辣的暑假結束，又迎來九月開學季了！   2018年8月24日新福港築愛義工團隊開展了 “暖陽開學季” 愛心捐贈活動，為智障兒童放送開學禮。`
        },
        {
          cover: 'static/images/news/20180921_03.jpg',
          publishTime: '2018-09-21 00:00:00',
          title: '2018·爱在“新”秋同乐会',
          subheading: `2018·爱在“新”秋同乐会`,
          fantiTitle: '2018·愛在“新”秋同樂會',
          fantiSubheading: `2018·愛在“新”秋同樂會`
        }
      ],
      newList: [],
      isshow: true,
      notNextTick: true,
      swiperOption: {
        autoplay: true,
        loop: false,
        direction: 'horizontal',
        effect: 'fade',
        grabCursor: true,
        setWrapperSize: true,
        autoHeight: true,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev'
        },
        mousewheelControl: false,
        observeParents: true,
        debugger: true,
        onTransitionStart (swiper) {
          // console.log(swiper)
        }
      }
    }
  },
  computed: {
    swiper () {
      return this.$refs.mySwiper.swiper
    },
    getLang () {
      return this.$store.state.lang
    }
  },
  mounted () {
    // console.log(this.swiper)
    // this.swiper.slideTo(3, 1000, false)
  },
  beforeMount () {
    var _this = this
    window.onresize = function () { // 定义窗口大小变更通知事件
      _this.screenWidth = document.documentElement.clientWidth // 窗口宽度
      if (_this.screenWidth > 1500) {
        this.isshow = false
      } else {
        this.isshow = true
      }
    }
  },
  methods: {
    changeH () {
      console.log('ceshi')
      this.isshow = !this.isshow
      console.log(this.isshow)
    }
  },
  created () {
    // this.$axios.get('http://223.4.157.105:8081/api/xinfugang/news/list')
    // this.$axios.get('http://localhost:8088/api/xinfugang/news/list')
    this.$axios.get('https://www.sfkp.cn/api/xinfugang/news/list')
      .then(res => {
        // 连接成功后对数据长度<=0的情况下
        if (res.data.data.length <= 0) {
          this.$message({
            message: '获取新闻数量为0，请检查后台是否正确上传首页新闻内容！',
            type: 'warning'
          })
          this.newList = this.defaultList
          return false
        }
        // 连接成功后对数据长度>的情况下
        // let newImgList = []
        this.newList = res.data.data
      })
      .catch(error => {
        this.newList = this.defaultList
        this.$message({
          message: '网络连接失败，请检查网络状况，或稍后再试！',
          type: 'warning'
        })
        console.log(error)
        // alert('加载远程资源失败,请检查网络或稍后再试~')
      })
  }
}
</script>

<style scoped lang="stylus">
  @import "~styles/varibles"
  @import "~styles/mixins"
  .ms > .swiper-wrapper > div:not(.swiper-slide-active)
    opacity 0!important
  .title
    width 100%
    text-align center
    padding-bottom 30px
    .en
      en()
      font-size 40px
    .cn
      cn()
      font-size 24px
  .swiper-btn
    background-image none
    top 45px
    left 0
    width 50px
    height 50px
  .swiper-button-prev
    background url("~assets/home/arrow-left.png")center left no-repeat
  .swiper-button-next
    background url("~assets/home/arrow-right.png")center right no-repeat
    left 190px
  .ms
    height 100%
    setHeight()
    padding-bottom 45%
  .news
    padding 83px 18.75% 93px
    background-image  url("~assets/home/news-bg.png")
    fullBg()
    .container
      position relative
      .item
        display flex
        cursor pointer
        position relative
        left -10px
        .left
          width 62%
          position relative
          right -20px
          .time
            color #353535
            font-size 20px
            width 240px
            text-align center
            padding 40px 10px
            position relative
            left -30px
          .box
            width 100%
            height 200px
            margin-top 2%
            .box-title
              cn()
              font-size 24px
              line-height 50px
              font-weight bold
            .box-text
              font-size 15px
              line-height 30px
              padding-top 2%
              padding-right 70px
          .more
            box-sizing border-box
            border 2px solid $defaultTheme
            width 138px
            height 43px
            color $defaultTheme
            text-align center
            line-height 43px
            margin-top 30px
        .right
          width 38%
          position relative
          .img
            position absolute
            top 0%
            left 0
            width 100%
            z-index 2
          .bg
            position absolute
            top 30px
            right 140px
            width 100%
            z-index 1
      .icon
        .line:after
          position absolute
          top 65px
          left 0px
          content: ''
          width 240px
          height 2px
          background #A8A8A8
          z-index 3
  @media screen and (min-width: 1300px) {
    .news >>> .box {
      height 40%!important
    }
    .bg {
      top 40px!important
    }
  }
  @media screen and (min-width: 1800px) {
    .news >>> .box {
      height 60%!important
    }
  }
  @media screen and (min-width: 2300px) {
    .news >>> .box {
      height 90%!important
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/home/components/News.vue